// frontend/src/pages/EditReview.jsx
import React from "react";
import ErrorBoundary from "../components/ErrorBoundary.jsx";
import { useParams, useNavigate } from "react-router-dom";
import { useReviewForm } from "../hooks/useReviewForm";
import ReviewFormComponent from "../components/ReviewFormComponent";

export default function EditReview() {
  const { id } = useParams();
  const navigate = useNavigate();
  const reviewId = parseInt(id, 10);

  const formProps = useReviewForm(reviewId);

  const handleSaveSuccess = () => {
    // Navigate back to company page - we need to get company_id
    if (formProps.companySel?.id) {
      navigate(`/company/${formProps.companySel.id}#reviews`);
    } else {
      // Fallback to review page if no company info
      navigate("/review");
    }
  };

  const handleCancel = () => {
    if (formProps.companySel?.id) {
      navigate(`/company/${formProps.companySel.id}#reviews`);
    } else {
      navigate("/review");
    }
  };

  if (!reviewId || isNaN(reviewId)) {
    return (
      <ErrorBoundary componentName="EditReviewPage">
        <div className="container">
          <h1 className="page-title">Edit Review</h1>
          <div className="card error-card">
            <div className="error-title">Invalid Review ID</div>
            <div className="error-body">The review ID provided is not valid.</div>
          </div>
        </div>
      </ErrorBoundary>
    );
  }

  return (
    <ErrorBoundary componentName="EditReviewPage">
      <ReviewFormComponent {...formProps} title="Edit Risk Review" onSaveSuccess={handleSaveSuccess} onCancel={handleCancel} showCancelButton={true} />
    </ErrorBoundary>
  );
}
